import { Component, inject, OnInit } from '@angular/core';
import {
  Availability,
  Product,
  SimplifiedAvailability,
  ProductInputQuantityConfigService
} from 'gung-standard';
import { first, takeUntil } from 'rxjs';
import { OttoOlsenProductDetailsComponent } from '../../otto-olsen-product-details/otto-olsen-product-details.component';
import { fnProductName } from '../../../pipes/product-name.pipe';

@Component({
    selector: 'otto-olsen-mobile-product-details',
    templateUrl: './otto-olsen-mobile-product-details.component.html',
    styleUrls: ['./otto-olsen-mobile-product-details.component.scss'],
    standalone: false
})
export class OttoOlsenMobileProductDetailsComponent extends OttoOlsenProductDetailsComponent implements OnInit {
  protected productInputQuantityConfigService = inject(ProductInputQuantityConfigService);

  public number = n => Number(n);
  roles: string[];
  currentQty: number;

  ngOnInit(): void {
    super.ngOnInit();

    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.roles = roles;
    });

    this.cartService
      .getProductQty(this.productId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(qty => {
        setTimeout(() => {
          this.currentQty = qty;
        }, 0);
      });
  }

  add(product: Product, availability: Availability | SimplifiedAvailability, qtyToAdd: number) {
    if (!this.productInputQuantityConfigService.getAllowPurchaseOverAvailability(this.currentQty + qtyToAdd, availability, product, this.roles)) {
      return;
    }
    this.cartService.addToCart(product.id, qtyToAdd, undefined, undefined, undefined, undefined, undefined, fnProductName(product));
  }

  subtract(product: Product, availability: Availability | SimplifiedAvailability, qtyToSubtract: number) {
    this.cartService.subtractFromCart(product.id, qtyToSubtract);
  }
}
